<div class="success-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner"></div>
    <p>Loading order details...</p>
  </div>

  <!-- Success Content -->
  <div *ngIf="!isLoading" class="success-content">
    <!-- Success Icon & Message -->
    <div class="success-header">
      <div class="success-icon">
        <i class="fas fa-check"></i>
      </div>
      <h1>Thank You for Your Order!</h1>
      <p class="success-message">Your registration has been confirmed and a confirmation email has been sent to your inbox.</p>
    </div>

    <!-- Order Details Card -->
    <div class="order-card" *ngIf="order">
      <div class="order-card-header">
        <div class="order-info">
          <span class="order-label">Order #</span>
          <span class="order-number">{{ order.order_id }}</span>
        </div>
        <div class="order-status" [ngClass]="'status-' + order.status">
          {{ order.status | uppercase }}
        </div>
      </div>

      <!-- Event Info -->
      <div class="event-section" *ngIf="event">
        <div class="event-icon">
          <i class="fas fa-calendar-alt"></i>
        </div>
        <div class="event-details">
          <h3>{{ event.event_name }}</h3>
          <p class="event-meta">
            <span *ngIf="event.start_date"><i class="fas fa-clock"></i> {{ formatDate(event.start_date) }}</span>
            <span *ngIf="event.city || event.country"><i class="fas fa-map-marker-alt"></i> {{ event.city }}<span *ngIf="event.city && event.country">, </span>{{ event.country }}</span>
          </p>
        </div>
      </div>

      <!-- Order Items -->
      <div class="order-items">
        <h4>Order Summary</h4>
        <div class="items-list">
          <div class="item-row" *ngFor="let line of order.order_lines">
            <div class="item-info">
              <span class="item-name">{{ line.description }}</span>
              <span class="item-qty" *ngIf="line.quantity > 1">x{{ line.quantity }}</span>
            </div>
            <span class="item-price">{{ formatPrice(line.total_cents, order.currency) }}</span>
          </div>
        </div>

        <!-- Total -->
        <div class="order-total">
          <span class="total-label">Total Paid</span>
          <span class="total-amount">{{ formatPrice(order.total_cents, order.currency) }}</span>
        </div>
      </div>

      <!-- Payment Info -->
      <div class="payment-info" *ngIf="order.paid_at">
        <i class="fas fa-credit-card"></i>
        <span>Paid on {{ formatDateTime(order.paid_at) }}</span>
      </div>
    </div>

    <!-- Generic Success (no order details) -->
    <div class="order-card" *ngIf="!order">
      <div class="generic-success">
        <i class="fas fa-envelope"></i>
        <p>Your registration is being processed. You will receive a confirmation email shortly with all the details.</p>
      </div>
    </div>

    <!-- What's Next Section -->
    <div class="next-steps">
      <h4>What's Next?</h4>
      <ul>
        <li><i class="fas fa-envelope"></i> Check your email for the confirmation and receipt</li>
        <li><i class="fas fa-user"></i> View your registrations in your profile</li>
        <li><i class="fas fa-calendar-check"></i> Mark the event date in your calendar</li>
      </ul>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn-secondary" (click)="goToEvent()">
        <i class="fas fa-arrow-left"></i> Back to Event
      </button>
      <button class="btn-primary" (click)="goToProfile()">
        <i class="fas fa-user"></i> View My Registrations
      </button>
    </div>
  </div>
</div>
